module.exports = __webpack_public_path__ + "img/logo8.800dd5e8.png";